module.exports = __webpack_public_path__ + "static/media/carousel-3.0c04ce8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel-3.jpg
// module id = 150
// module chunks = 1